const RELATIVE = new Intl.RelativeTimeFormat("de", { numeric: "auto" });
const DATE_TIME = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit"
});

export const AVATAR_TONES = 6;

export function formatRelativeTime(timestamp: number, now: number): string {
  const seconds = Math.round((timestamp - now) / 1000);
  const abs = Math.abs(seconds);
  if (abs < 45) {
    return RELATIVE.format(0, "second");
  }
  if (abs < 45 * 60) {
    return RELATIVE.format(Math.round(seconds / 60), "minute");
  }
  if (abs < 22 * 3600) {
    return RELATIVE.format(Math.round(seconds / 3600), "hour");
  }
  if (abs < 26 * 86400) {
    return RELATIVE.format(Math.round(seconds / 86400), "day");
  }
  if (abs < 320 * 86400) {
    return RELATIVE.format(Math.round(seconds / (30 * 86400)), "month");
  }
  return RELATIVE.format(Math.round(seconds / (365 * 86400)), "year");
}

export function formatDateTime(timestamp: number): string {
  return DATE_TIME.format(new Date(timestamp));
}

export function initialsOf(title: string): string {
  const words = title.trim().split(/\s+/).filter((word: string): boolean => word.length > 0);
  const letters = words
    .slice(0, 2)
    .map((word: string): string => Array.from(word)[0] ?? "")
    .join("")
    .toUpperCase();
  return letters === "" ? "?" : letters;
}

/** Deterministic palette index so the same title always gets the same monogram colour. */
export function avatarTone(seed: string): number {
  let hash = 0;
  for (const char of seed) {
    hash = (hash * 31 + (char.codePointAt(0) ?? 0)) | 0;
  }
  return Math.abs(hash) % AVATAR_TONES;
}

export function greetingName(email: string): string {
  const local = email.split("@")[0] ?? "";
  const first = local.split(/[._-]/)[0] ?? "";
  if (first === "") {
    return "";
  }
  return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
}
